import { render, staticRenderFns } from "./GoToTop.vue?vue&type=template&id=79bb47bb&scoped=true&"
import script from "./GoToTop.vue?vue&type=script&lang=js&"
export * from "./GoToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb47bb",
  null
  
)

export default component.exports